import { c as _c } from "react/compiler-runtime";
import { ThankYou, ThankYouCommonInterface } from '@systemeio/digital-store-shared';
import { FormInput } from '@systemeio/ui';
import ItemSteps from 'modules/stores/store/components/item-steps';
import { useStorePreviewContext } from 'modules/stores/store/context/store-preview-context';
import { ThankYouPageErrorsType } from 'modules/stores/store/types/store-common-interface';
import { FC, useEffect } from 'react';
import FormTextarea from 'shared/components/form-textarea';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ThankYouTabProps {
  thankYouPage: ThankYouCommonInterface['thankYouPage'];
  onChange: (thankYouPage: ThankYouCommonInterface['thankYouPage']) => void;
  errors: ThankYouPageErrorsType;
}
const ThankYouTab: FC<ThankYouTabProps> = t0 => {
  const $ = _c(33);
  const {
    thankYouPage,
    onChange,
    errors
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    setPreview,
    setSingleItemMode
  } = useStorePreviewContext();
  let t1;
  let t2;
  if ($[0] !== setPreview || $[1] !== setSingleItemMode || $[2] !== thankYouPage) {
    t1 = () => {
      setPreview([<ThankYou key="Thank you page preview" thankYouPage={thankYouPage} displayAffiliateLink={false} />]);
      setSingleItemMode(true);
    };
    t2 = [setPreview, setSingleItemMode, thankYouPage];
    $[0] = setPreview;
    $[1] = setSingleItemMode;
    $[2] = thankYouPage;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.store.item.add_text");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = thankYouPage.title;
  let t5;
  if ($[7] !== t) {
    t5 = t("dashboard.store.item.title");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onChange || $[10] !== thankYouPage) {
    t6 = t7 => {
      const {
        target: t8
      } = t7;
      const {
        value
      } = t8;
      return onChange({
        ...thankYouPage,
        title: value
      });
    };
    $[9] = onChange;
    $[10] = thankYouPage;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = errors["thankYouPage.title"];
  let t8;
  if ($[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== thankYouPage.title) {
    t8 = <FormInput required={true} value={t4} label={t5} onChange={t6} error={t7} />;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = thankYouPage.title;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = thankYouPage.text;
  let t10;
  if ($[17] !== t) {
    t10 = t("dashboard.store.item.subtitle");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== onChange || $[20] !== thankYouPage) {
    t11 = t12 => {
      const {
        target: t13
      } = t12;
      const {
        value: value_0
      } = t13;
      return onChange({
        ...thankYouPage,
        text: value_0
      });
    };
    $[19] = onChange;
    $[20] = thankYouPage;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = errors["thankYouPage.text"];
  let t13;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== thankYouPage.text) {
    t13 = <FormTextarea required={true} value={t9} label={t10} onChange={t11} error={t12} />;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = thankYouPage.text;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t8) {
    t14 = <div className="flex flex-col gap-5">{t8}{t13}</div>;
    $[27] = t13;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14 || $[31] !== t3) {
    t15 = <ItemSteps steps={[{
      key: "text",
      title: t3,
      element: t14
    }]} />;
    $[30] = t14;
    $[31] = t3;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
};
export default ThankYouTab;